import Vue from 'vue'
import VuePageTitle from 'vue-page-title'
import App from './App.vue'
import router from './router'
import store from './store'
import NProgress from 'vue-nprogress'
import FirebaseAuthService from './services/firebase'
import VueLayers from 'vuelayers'
import BootstrapVue from 'bootstrap-vue'

import {
    Avatar,
    TreeSelect,
    Rate,
    Breadcrumb,
    InputNumber,
    Steps,
    Message,
    Upload,
    Button,
    Layout,
    Table,
    Icon,
    Progress,
    Radio,
    Dropdown,
    Menu,
    Carousel,
    Input,
    Calendar,
    Badge,
    Slider,
    Form,
    Tooltip,
    Select,
    Switch,
    Tag,
    Affix,
    Spin,
    Alert,
    Checkbox,
    Tabs,
    Pagination,
    notification,
    Drawer,
    Cascader,
    DatePicker,
    TimePicker,
    Divider,
    List,
    Card,
    Modal,
} from 'ant-design-vue'

import './global.scss'
import { countryConfig } from './country-config/country-config'
const moment = require('moment')
require('moment/locale/es')

Vue.use(BootstrapVue)
Vue.use(VueLayers)
Vue.use(Avatar)
Vue.use(Divider)
Vue.use(Button)
Vue.use(Rate)
Vue.use(TreeSelect)
Vue.use(Breadcrumb)
Vue.use(Layout)
Vue.use(Table)
Vue.use(Icon)
Vue.use(Progress)
Vue.use(Radio)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Carousel)
Vue.use(Input)
Vue.use(Calendar)
Vue.use(Badge)
Vue.use(Slider)
Vue.use(Form)
Vue.use(Tooltip)
Vue.use(Select)
Vue.use(Tag)
Vue.use(Affix)
Vue.use(Spin)
Vue.use(Alert)
Vue.use(Checkbox)
Vue.use(Tabs)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Message)
Vue.use(Steps)
Vue.use(InputNumber)
Vue.use(Drawer)
Vue.use(Modal)
Vue.use(Switch)
Vue.use(Cascader)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(List)
Vue.use(Card)
Vue.use(notification)

Vue.use(require('vue-moment'), {
    moment,
})

Vue.prototype.$notification = notification

Vue.use(NProgress)
Vue.use(FirebaseAuthService)
Vue.use(VuePageTitle, {
    prefix: countryConfig.isColombia ? 'CMS Farmatodo Colombia' : 'CMS Farmatodo Venezuela' + ' | ',
    router,
})
Vue.config.productionTip = false
const nprogress = new NProgress({ parent: 'body' })

new Vue({
    router,
    store,
    nprogress,
    render: h => h(App),
}).$mount('#app')